import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DivisionListRes;
export const DivisionListTodo = createAsyncThunk('DivisionList', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'division_list',
            data: {
                "vcust_plant_code": "S/01/01",
            },
            headers: { "Content-Type": "application/json" }
        })
        return DivisionListRes = res.data

    } catch (error) {
        return DivisionListRes = error.response.data
    }
})

const DivisionListSlice = createSlice({
    name: 'DivisionList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(DivisionListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(DivisionListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default DivisionListSlice.reducer; 